import API from '../api'

export default {
  getSubjectData({ commit }) {
    API.getSubjectData()
      .then(gradeSubject => {
        commit('GET_SUBJECT_DATA', gradeSubject)
      })
      .catch(function(error) {
        commit('GET_SUBJECT_DATA', null)
        console.log(error)
      })
  },
  saveUrlQuery({commit,state},payload){
    const urlQueryObj = Object.assign({},payload);
    state.urlQueryObj = urlQueryObj;
  },
  bindSuccess({commit,state},payload){
    state.urlQueryObj.isBind = "1";
  }
}
